export default __webpack_public_path__ + "static/slider-1-50440af37cb2a90eb3d8430cd846d30d.webp";